import { render, staticRenderFns } from "./NewDocuments.vue?vue&type=template&id=508cc79e"
import script from "./NewDocuments.vue?vue&type=script&lang=js"
export * from "./NewDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports